const isEnabled = (string, array) => (array || []).includes(string);

export default isEnabled;
